import * as C from "../mock";

const GALLERY = [
  { src: "/assets/getaway/highlights/g8.png", caption: "Squad Goals", span: "lg:col-span-2 lg:row-span-2" },
  { src: "/assets/getaway/highlights/g2.png", caption: "Island Paradise", span: "" },
  { src: "/assets/getaway/highlights/g7.png", caption: "Resort Vibes", span: "" },
  { src: "/assets/getaway/highlights/g4.png", caption: "Island Ports", span: "lg:col-span-2" },
  { src: "/assets/getaway/highlights/g5.png", caption: "Live DJ Sets", span: "" },
  { src: "/assets/getaway/highlights/g6.png", caption: "Party Nights", span: "lg:col-span-2" },
];

const caribbean = {
  ...C,
  GALLERY,
  id: "caribbean-2027",
  themeGold: "#F2C04C",
  logo: "/logo-hhas.webp",
  logoAlt: "House Heads At Sea 2027 - The Getaway",
  experienceKicker: "7 Unforgettable Nights Of",
  hero: {
    paragraph:
      "7-Night Caribbean Cruise sailing aboard the all-new Norwegian Prima. Seven unforgettable nights of non-stop house music, pool parties & island vibes.",
    marquee: [
      "Non-Stop House Music",
      "Pool Parties",
      "Theme Nights",
      "Live DJ Sets",
      "Dancing",
      "7 Islands",
      "And More!",
    ],
    countdownTarget: "2027-12-04T16:00:00-04:00",
  },
};

export default caribbean;
